import React from 'react'
import { TabView, TabPanel } from "primereact/tabview";
import TabviewBikes from '../ProductBikes/TabviewBikes';
import TabViewCars from '../ProductCars/TabViewCars';
import TabviewCycles from '../ProductCycles/TabviewCycles';
import TabToys from '../ProductToys/TabToys';
import TabViewGiftsAndArts from '../ProductGiftsAndArts/TabViewGiftsAndArts';
// import './AdminDashboard.css';        

function AdmnDashboard() {
  return (
    <div className="px-3 md:px-5 lg:px-6 mt-4 custom-tabview">
      <TabView className="responsive-tabview">
        <TabPanel header="Cars">
          <TabViewCars />
        </TabPanel>
        <TabPanel header="Bikes">
          <TabviewBikes />
        </TabPanel>
        <TabPanel header="Cycle">
          <TabviewCycles />
        </TabPanel>
        <TabPanel header="Toys">
          <TabToys />
        </TabPanel>
        <TabPanel header="Gifts And Arts">
          <TabViewGiftsAndArts />
        </TabPanel>
      </TabView>
    </div>
  );
}

export default AdmnDashboard;